import { getPathFromUrl } from '~commonInfra/url/UrlHelpers';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { Messages } from '../../../codegen/Localize';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { getContentSpaceDefinition } from '../../contentDefinitionInterfaces/ContentDefinitionsLists';
import {
  INamedItemInfo,
  ISpaceTypeInfo
} from '../../models/resourceInfoParts';
import { addQuery, SpacesSiteUrls } from '../spaceComponents/SpacesSiteUrls';
import { BreadcrumbStateInfo } from './BreadcrumbStateInfo';

export function populateContentBreadcrumbs(contentPath: ISpaceTypeInfo[], siteUrls: SpacesSiteUrls) {
  if (!siteUrls) {
    return;
  }

  let rootHref = addQuery(siteUrls.exploreUrl());

  const rootBreadcrumb: BreadcrumbStateInfo = getRootBreadcrumb(rootHref, Messages.explore());

  const contentBreadcrumbs: BreadcrumbStateInfo[] =getContentBreadcrumb(siteUrls, contentPath);

  getAppStore().dispatch(updateBreadcrumbs([].concat(rootBreadcrumb).concat(contentBreadcrumbs)));
}

export function populateBreadcrumbsForPS(contents: ISpaceTypeInfo[], siteUrls: SpacesSiteUrls) {
  if (!siteUrls) {
    return;
  }

  const content = contents[0] as IContentInfo;
  const ownerId = content.owner.id;
  const currentUserId = SessionUserSelectors.sessionUserId(getAppStore().getState());
  let rootHref = (ownerId === currentUserId)? addQuery(siteUrls.personalSpaceUrl()) : null;

  const rootBreadcrumb: BreadcrumbStateInfo = getRootBreadcrumb(rootHref, Messages.navigation_personalSpace());

  const contentBreadcrumbs: BreadcrumbStateInfo[] = getContentBreadcrumb(siteUrls, contents);
  getAppStore().dispatch(updateBreadcrumbs([].concat(rootBreadcrumb).concat(contentBreadcrumbs)));
}

export function addContentTypeToProjectHierarchy(projectHierarchy: INamedItemInfo[]): ISpaceTypeInfo<'project'>[] {
  if (!projectHierarchy){
    return [];
  }

  return projectHierarchy.map(project => {
    const ret: ISpaceTypeInfo<'project'> = {
      ...project,
      contentType: 'project'
    };
    return ret;
  });
}

function getRootBreadcrumb(rootHref: string, message: string): BreadcrumbStateInfo {
  return {
    id: getPathFromUrl(rootHref),
    text: message,
    href: rootHref,
    testId: 'breadcrumb-content-root'
  };
}

export function getContentBreadcrumb(siteUrls: SpacesSiteUrls, contentPath: ISpaceTypeInfo[]): BreadcrumbStateInfo[] {
  return (contentPath.map(item => {
    const href = getContentSpaceDefinition(item.contentType).contentSpaceUrl(siteUrls, item.id, '');
    return {
      id: getPathFromUrl(href),
      // W-23717184: the server withholds the *name* of ancestor projects the caller
      // cannot read (IDOR fix) while keeping the id so the path stays linkable. Show a
      // localized "Hidden" label for those ancestors instead of a blank crumb.
      text: item.name || Messages.breadcrumbHiddenProjectName(),
      href: href,
      testId: `breadcrumb-${item.contentType}-${item.id}`
    };
  }));
}
